export interface FormTemplateType {
  id: string;
  name: string;
  category: string;
  active: boolean;
  selected: boolean;
  progressInfos: ProgressInfos
}

export interface ProgressInfos {
  injectedCode: number;
  updatedCode: number;
  status: 'IN_PROGRESS' | 'COMPLETED' | 'FAILED' | 'WAITING';
}

export enum FormTemplateTypeEnum {
  DEPT_GENERAL_PRACTICE = 'deptgeneralpractice',
  DEPT_PHYSIOTHERAPY = 'deptphysiotherapy',
  ORG_REVALIDATION_CENTER = 'orgrevalidationcenter'
}
